import Button from "./Button";

export function ExcelUploadButton({ onClick, disabled }) {
  return (
    <Button
      type="primary"
      label="Excel upload"
      size="small"
      disabled={disabled}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
